export const WEBSOCKET_AVAILABLE_PROVIDERS = {
  NATIVE: 'NATIVE',
  SOCKET_IO: 'SOCKETIO',
} as const;

export type WebsocketAvailableProvider = typeof WEBSOCKET_AVAILABLE_PROVIDERS[keyof typeof WEBSOCKET_AVAILABLE_PROVIDERS];
